import { Component } from "react";
import { IcWarning, IcRefresh } from "./Icons";

/**
 * React Error Boundary — yakalanmamış JS hatalarının tüm paneli çökertmesini önler.
 *
 * Kullanım:
 *   <ErrorBoundary>
 *     <App />
 *   </ErrorBoundary>
 *
 * Hata olduğunda tüm beyaz ekran yerine kullanıcı dostu geri yükleme ekranı gösterir.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Loglama servisine gönderilebilir — şimdilik console yeterli
    console.error("[ErrorBoundary] Yakalanmamış hata:", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        display:        "flex",
        flexDirection:  "column",
        alignItems:     "center",
        justifyContent: "center",
        height:         "100vh",
        gap:            "16px",
        fontFamily:     "sans-serif",
        color:          "#333",
        padding:        "24px",
        textAlign:      "center",
      }}>
        <div style={{ color: "#e57373", display:"inline-flex" }}><IcWarning size={48} /></div>
        <h2 style={{ margin: 0 }}>Panel Hatası</h2>
        <p style={{ color: "#666", maxWidth: "400px", margin: 0 }}>
          Beklenmedik bir hata oluştu. Sayfayı yenileyin veya destek ekibine bildirin.
        </p>
        <details style={{
          marginTop:  "8px",
          fontSize:   "12px",
          color:      "#999",
          maxWidth:   "500px",
          textAlign:  "left",
          whiteSpace: "pre-wrap",
          wordBreak:  "break-word",
        }}>
          <summary style={{ cursor: "pointer" }}>Hata detayı</summary>
          {this.state.error?.toString()}
        </details>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop:    "8px",
            padding:      "10px 24px",
            background:   "#2563eb",
            color:        "#fff",
            border:       "none",
            borderRadius: "8px",
            fontSize:     "15px",
            cursor:       "pointer",
            display:      "inline-flex",
            alignItems:   "center",
            gap:          "8px",
          }}
        >
          <IcRefresh size={16} /> Sayfayı Yenile
        </button>
      </div>
    );
  }
}
